import cx from "classnames";
import MainItem from "./MainItem";
import styles from "./WellbeingCentre.module.scss";
import SubItem from "./SubItem";
import { formatTimeDisplay } from "@utils/dateFormatter";
import ClientWrapper from "@containers/ClientWrapper";
const WellbeingCentreKey = "WellbeingCentre";
import _ from "lodash";
export default function WellbeingCentre({ data, articles }: any) {
  const tabs: any = [
    {
      key: "WellbeingCentre",
      image: _.get(data, "image"),
      title: _.get(data, "title"),
      content: _.get(data, "description"),
      shouldEnquire: false,
      moreInfo: {
        time: `${formatTimeDisplay(
          _.get(data, "openTime"),
          "HH:mm:ss"
        )} - ${formatTimeDisplay(_.get(data, "closeTime"), "HH:mm:ss")}`,
        phone: _.get(data, "phone"),
        floor: _.get(data, "location"),
      },
    },
  ];
  return (
    <div className={cx(styles.section)}>
      <ClientWrapper>
        <MainItem
          swiperClass="WellbeingCentre"
          activeTab={WellbeingCentreKey}
          onChange={() => {}}
          tabs={tabs}
        />
      </ClientWrapper>
      <div className={cx(styles.wrapperSubItem)}>
        {_.map(articles, (item: any, index: number) => (
          <SubItem
            key={index}
            data={{
              ...item,
              image: {
                ..._.get(item, "image"),
                placement: cx({ right: index % 2 === 0 }),
              },
              time: _.get(item, "subtitle"),
              content: _.get(item, "description"),
            }}
          />
        ))}
      </div>
    </div>
  );
}
